import { Badge } from '@mui/material';
import React, { ReactNode } from 'react';
import './badge.scss';

export const AppBadge = (props: { counter: number; children?: ReactNode }) => (
	<Badge className='app-badge' badgeContent={props.counter}>
		{props.children}
	</Badge>
);
